<template>
  <div class="client">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <client-user-component
              ref="client_component"
              :client_id="client_id"
              @back="backToDashboard()"
            ></client-user-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClientUserComponent from "@/components/clients/ClientUserComponent";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import axios from "@/api/axios";
import { bus } from "@/main";

export default {
  name: "client",
  components: {
    ClientUserComponent
  },
  props: {
    client_id: Number
  },
  data() {
    return {
       items: [
        {
          text: "Área do Cliente",
          route: "client.dashboard"
        },
        {
          text: "Editar usuário",
          active: true
        }
      ]
    };
  },
  mounted() {
    bus.$emit("changeLoading", true);
    this.getLoggedUser();
    this.providerData();
  },

  methods: {
    getLoggedUser: function() {
      this.client_id = localStorage.getItem("auth.user_id");
      this.providerData();
    },
    providerData: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/users/${this.client_id}`)
        .then(response => {
          this.client = response.data;
          this.client.client = true;
          this.$refs.client_component.editClient(this.client);
          bus.$emit("changeLoading", false);
        });
    },
    backToDashboard: function() {
      this.$router.push({ name: "client.dashboard" });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>